import * as React from "react"
import { GatsbyLinkProps, Link } from "gatsby"

import { VBox, Spacer } from "@molnx-sites/common/components"

import styles from "./DocBox.module.scss"


export function DocBox(props: {
    title: string
    indexPath: string
    description: string
    links: GatsbyLinkProps<any>[]
}) {
    return (
        <VBox className={styles.DocBox}>
            <h2><Link to={props.indexPath}>{props.title}</Link></h2>
            <p>{props.description}</p>
            <Spacer />
            <ul>
                {props.links.map(it => (
                    <li><Link key={it.to} {...it} ref={undefined} /></li>
                ))}
            </ul>
        </VBox>
    )
}
